import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IStatesApiClient } from './i-states-api.client';
import {
  IStateResponse,
  ICreateStateRequest,
  IUpdateStateReqeust,
} from '../dtos';
import { LocationManagementCollections } from '../../common/collections';
import { CollectionApiClient, IPaginationResponse, ISoftDeletablePaginationParameters } from '../../../data-access';
import { ICreateStateResponse } from '../dtos/responses/create.state.response';
import { ICityResponse } from '../../cities/dtos';

@Injectable({
  providedIn: 'root'
})
export class StatesApiClient implements IStatesApiClient {
  private collectionApiClient: CollectionApiClient;

  constructor(protected http: HttpClient) {
    this.collectionApiClient = CollectionApiClient.create(
      LocationManagementCollections.States,
      http
    );
  }

  get(
        paginationParameters?: ISoftDeletablePaginationParameters
    ): Observable<IPaginationResponse<IStateResponse>> {
      return this.collectionApiClient.get({
        paginationParameters
      });
    }

  getById(id: string): Observable<IStateResponse> {
    return this.collectionApiClient.get({
      id
    });
  }

  create(request: ICreateStateRequest): Observable<ICreateStateResponse> {
    return this.collectionApiClient.post({
      body: request
    });
  }

  update(id: string, request: IUpdateStateReqeust): Observable<void> {
    return this.collectionApiClient.put({
      id,
      body: request
    });
  }

  getCities(
    stateId: string,
    paginationParameters?: ISoftDeletablePaginationParameters
  ): Observable<IPaginationResponse<ICityResponse>> {
    return this.collectionApiClient.get({
      collectionName: LocationManagementCollections.stateCities(stateId),
      paginationParameters
    });
  }
}
